import React from 'react';
import { PatternFormat } from 'react-number-format';
import { useField } from "formik";
import { Form } from "react-bootstrap";

export default function CardNumberField({ name, label, controlId, ...props }) {
  const [field, meta, helpers] = useField(name);
  const { setValue } = helpers;

  return (
    <Form.Group controlId={controlId}>
      <Form.Label>{label}</Form.Label>
      <PatternFormat 
        name={name} 
        customInput={Form.Control}
        value={field.value}
        onValueChange={(values, sourceInfo) => {
          console.log(values, sourceInfo);
          setValue(values.value);
        }}
        format="#### #### #### ####"
        mask="_"
        className={meta.error && meta.touched ? "border border-danger" : ""}
        allowLeadingZeros
        {...props} 
      />
      {meta.error && meta.touched ? (
        <small className='text-danger'>{meta.error}</small>
      ) : null}
    </Form.Group>
  );
}
